import React from 'react'
import { Grid } from '@material-ui/core'
import { VariableContexte } from '../../../store/constants/fonction/variable-contexte'
import { useForm } from 'react-hook-form'
import {
  createVariableContexte,
  updateVariableContexte,
} from '../../../store/actions/fonction/variable-contexte-action'
import { useDispatch } from 'react-redux'
import { ValidationButton } from '../../common/validation-button'
import { CancelButton } from '../../common/cancel-button'
import { CreationVariableContexteForm } from './CreationVariableContexteForm'

export const CreationVariableContexte = ({ classes, toEdit, handleClose }) => {
  const dispatch = useDispatch()
  const useFormObj = useForm({
    values: toEdit ? toEdit : new VariableContexte(),
  })

  const handleCancel = () => {
    handleClose()
  }
  const handleSaveVariableContexte = data => {
    const dataToSave = { ...data }
    if (dataToSave.referenceObj && dataToSave.referenceObj.nom) {
      dataToSave.reference = dataToSave.referenceObj.nom
      delete dataToSave.referenceObj
    }
    if (toEdit) {
      dataToSave.nom = toEdit.nom
      dispatch(updateVariableContexte(dataToSave))
    } else {
      dispatch(createVariableContexte(dataToSave))
    }
  }
  return (
    <>
      <Grid item xs={12} style={{ marginTop: 15, marginBottom: 15 }}>
        <CreationVariableContexteForm useFormObj={useFormObj} classes={classes} toEdit={toEdit} />
      </Grid>
      <Grid>
        <ValidationButton
          variant="contained"
          size="medium"
          color="primary"
          onClick={useFormObj.handleSubmit(handleSaveVariableContexte)}
          className={classes.margin}
        >
          ENREGISTRER
        </ValidationButton>
      </Grid>
      <Grid>
        <CancelButton
          variant="contained"
          size="medium"
          color="primary"
          onClick={handleCancel}
          className={classes.margin}
        >
          ANNULER
        </CancelButton>
      </Grid>
    </>
  )
}
